import { AfterViewInit, Component, ElementRef, Input, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbModal, NgbProgressbarModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, filter, tap } from 'rxjs/operators';
import { AlternateScoringModel } from 'src/app/clients-module/models/clientLocation';
import { ClientService } from 'src/app/clients-module/services/client.service';

@Component({
  selector: 'app-riq-slider-v2',
  templateUrl: './riq-slider-v2.component.html',
  styleUrls: ['./riq-slider-v2.component.less']
})
export class RiqSliderV2Component implements AfterViewInit {
  @ViewChildren('deny, cl, ch, accept') leBubbles : QueryList<ElementRef>;
  @ViewChild('sliderInputs',{ }) form : NgForm;
  
  @Input() altScoringModel: AlternateScoringModel;
  errors: boolean = false;



  public get A() {
    return `${this.altScoringModel.recDecAccept} - 100`;
  }
  public get CH() {
    return `${this.altScoringModel.recDecConditionalHigh} - ${this.altScoringModel.recDecAccept-1}`;;
  }
  public get CL() {
    return `${this.altScoringModel.recDecConditionalLow} - ${this.altScoringModel.recDecConditionalHigh-1}`;
  }
  public get D() {
    return `0 - ${this.altScoringModel.recDecConditionalLow-1}`;
  }
  public get confirmButtonText() : string {
    if(this.altScoringModel.id == 0) return 'Save New Model'
    else return 'Update Model'
  }



  public sliderBubbleRefs: any[] = [];

  constructor(private renderer: Renderer2, public modalRef: NgbModal, public clients: ClientService, public toast: ToastrService) {

  }

  private _a: number;
  private _ch: number;
  private _cl: number;

  ngAfterViewInit(): void {
    this._a = this.altScoringModel.recDecAccept;
    this._ch = this.altScoringModel.recDecConditionalHigh;
    this._cl = this.altScoringModel.recDecConditionalLow;
    this.updateBubbles();
    this.form.statusChanges.pipe(
      // filter(()=>{ return this.form.valid && this.form.dirty; }),
      debounceTime(200)
    ).subscribe(()=>{
      console.log(this.form.form);
      this.updateBubbles();
      this.hasErrors();
    })
  }

  updateThresholds() : void {
    //just in case they're quick on the submission, run this again to be safe:
    this.hasErrors();

    if(this.errors) {
      this.toast.error('Uh oh! Please review the recommended decision values.');
      return;
    }

    if(this.altScoringModel.id == 0) {
      this.clients.SaveAlternateScoringModel(this.altScoringModel).pipe(tap((_: number) => {

        this.toast.success("Model saved.");
        this.altScoringModel.id = _; 
        // this.altModels.push(this.loadedModel);
        //TODO: output saved model to the client list

      },err => {
        
      },
      () => {
        this.modalRef.dismissAll();
      })).subscribe();
    }
    else {
      this.clients.UpdateAlternativeScoringModel(this.altScoringModel).pipe(tap((_:boolean) => {
        this.toast.success("Model updated.");
      },
      err => {
        this.toast.error("Error updating model", "", { closeButton: true })
      },
      () => {
        this.modalRef.dismissAll();
      })).subscribe();
    }
  }

  handleValueUpdate() {
    
  }

  hasErrors() : void {
    this.errors = false;
    //if CL is > CH or A, error; if CH is > A or < CL, error
    if(this.altScoringModel.recDecConditionalLow > this.altScoringModel.recDecConditionalHigh || 
      this.altScoringModel.recDecConditionalLow > this.altScoringModel.recDecAccept
    ) this.errors = true;

    if(this.altScoringModel.recDecConditionalHigh > this.altScoringModel.recDecAccept || 
      this.altScoringModel.recDecConditionalHigh < this.altScoringModel.recDecConditionalLow
    ) this.errors = true;

    //scoringModelName must have at least 3 chars, no more than 100
    if(!this.altScoringModel.scoringModelName || this.altScoringModel.scoringModelName.length < 3 || this.altScoringModel.scoringModelName.length > 100) {
      this.errors = true;
    }

    //scoring model name SHOULD NOT CONTAIN 'Location Default' or 'Client Default'
    if((this.altScoringModel.scoringModelName.toLowerCase().includes('location default') || this.altScoringModel.scoringModelName.toLowerCase().includes('client default')) && !this.altScoringModel.onCreationScoringModel) {
      this.errors = true;
    }
  }

  updateBubbles() : void {
    this.sliderBubbleRefs = [
      { bubbleId: "deny-bubble", width: this.altScoringModel.recDecConditionalLow-1, labelText: this.D, bubbleClasses: "bubble cell-red end-left" }, 
      { bubbleId: "conlow-bubble",  width: this.altScoringModel.recDecConditionalHigh-1-this.altScoringModel.recDecConditionalLow, labelText: this.CL, bubbleClasses: "bubble cell-orange" }, 
      { bubbleId: "conhigh-bubble", width: this.altScoringModel.recDecAccept-1-this.altScoringModel.recDecConditionalHigh, labelText: this.CH, bubbleClasses: "bubble cell-yellow" }, 
      { bubbleId: "accept-bubble", width: 100-this.altScoringModel.recDecAccept, labelText: this.A, bubbleClasses: "bubble cell-green end-right" }, 
    ]
    this.leBubbles.forEach(bb => {
      let bubbleRef = this.sliderBubbleRefs.find(el => bb.nativeElement.id == el.bubbleId)
      this.renderer.setStyle(bb.nativeElement, 'width', `${bubbleRef.width}%`)
      bb.nativeElement.classList.add('load-bubble');
      let tim = setTimeout(() => {
        bb.nativeElement.classList.remove('load-bubble');
      }, 250);

    });
  }
  cancel() : void {
    this.altScoringModel.recDecAccept = this._a;
    this.altScoringModel.recDecConditionalHigh = this._ch;
    this.altScoringModel.recDecConditionalLow = this._cl;
    this.modalRef.dismissAll();
  }
}
